import { Badge } from "@/components/ui/badge";

const C = {
  green: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/30",
  blue: "bg-blue-500/15 text-blue-700 dark:text-blue-400 border-blue-500/30",
  amber: "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/30",
  purple: "bg-purple-500/15 text-purple-700 dark:text-purple-400 border-purple-500/30",
  slate: "bg-slate-500/15 text-slate-700 dark:text-slate-400 border-slate-500/30",
  rose: "bg-rose-500/15 text-rose-700 dark:text-rose-400 border-rose-500/30",
  cyan: "bg-cyan-500/15 text-cyan-700 dark:text-cyan-400 border-cyan-500/30",
};

const MAP = {
  Stokta: "green", Satıldı: "blue", Rezerve: "amber", Serviste: "purple", Beklemede: "slate",
  Planlanıyor: "purple", "Devam Ediyor": "green", Aktif: "green", Tamamlandı: "blue", İptal: "rose",
  Ödendi: "green", Bekliyor: "amber", "Kısmen Ödendi": "cyan", Gecikmiş: "rose",
  Dışarıda: "amber", Döndü: "green", Gelir: "green", Gider: "rose",
  "Sipariş Verildi": "amber", "Teslim Edildi": "green",
};

export function StatusBadge({ value, testId }) {
  return (
    <Badge variant="outline" className={`${C[MAP[value]] || C.slate} font-medium whitespace-nowrap`} data-testid={testId}>
      {value || "-"}
    </Badge>
  );
}
